import { getAlcoholFact } from './alcoholFact';
import { getAllergensFact } from './allergensFact';
import { getBottleClosureFact } from './bottleClosureFact';
import { getCertificationFact } from './certificationFact';
import { getDietaryFact } from './dietaryFact';
import { getDrinkingWindowFact } from './drinkingWindowFact';
import { getGrapesFact } from './grapesFact';
import { getRegionFact } from './regionFact';
import { getWineDescription } from './wineDescription';
import { getWineStyleFact } from './wineStyleFact';
import { getWineryFact } from './wineryFact';

export const FACT_GETTERS = [
  getWineryFact,
  getGrapesFact,
  getRegionFact,
  getWineStyleFact,
  getDrinkingWindowFact,
  getAlcoholFact,
  getCertificationFact,
  getDietaryFact,
  getAllergensFact,
  getBottleClosureFact,
  getWineDescription,
];

export const getWineFacts = (vintage, translationFunc = null) => {
  return FACT_GETTERS.reduce((facts, getFact) => {
    const fact = getFact(vintage, translationFunc);
    if (fact) {
      facts.push(fact);
    }
    return facts;
  }, []);
};
